import { Map } from 'immutable';
import { NAVIGATE, NAVIGATION_COMPLETE } from '../actions/navigationActions';

export default function reduceNavigation(state = Map(), action = {}) {
  switch ((action as any).type) {
    case NAVIGATE:
      return state.set('pendingNavigation', (action as any).payload);
    case NAVIGATION_COMPLETE:
      return state.set('pendingNavigation', null);
    default:
      return state;
  }
}
